import styled, { css } from 'styled-components';
import TypographyStyle from '../Typography/TypographyStyle';
export const ParagraphStyleCSS = css `
  margin-top: 0;
  color: inherit;
`;
export default styled(TypographyStyle) `
  ${ParagraphStyleCSS};
`;
//# sourceMappingURL=ParagraphStyle.js.map